var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{staticClass:"info-table"},[_c('tbody',_vm._l((_vm.items),function(item,index){return _c('tr',{key:index},[_c('td',[_c('v-icon',{attrs:{"color":item.color,"small":""}},[_vm._v(_vm._s(item.icon))])],1),_c('td',[_vm._v(_vm._s(item.text))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }